import React from 'react';
import { Flex, LoadingIndicator } from 'roo-ui/components';

const LoaderComponent = () => {
  return (
    <Flex minHeight={150} alignItems="center" justifyContent="center">
      <LoadingIndicator />
    </Flex>
  );
};

export default LoaderComponent;
